
import { toast as sonnerToast } from "sonner";

type ToastProps = {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  variant?: "default" | "destructive";
};

export const useToast = () => {
  const toast = ({ title, description, action, variant }: ToastProps) => {
    if (variant === "destructive") {
      return sonnerToast.error(title, {
        description,
        action
      });
    }
    
    return sonnerToast(title || "", {
      description,
      action
    });
  };

  return { toast };
};

// Export the sonner toast directly
export { toast } from "sonner";
